export default __webpack_public_path__ + "static/media/Icons_Marina Icon.2945185b.svg";